<div class="edit-schedule-template">
  <div class="edit-schedule-template__row">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input
        matInput
        [ngModel]="templateName()"
        (ngModelChange)="templateName.set($event)"
        placeholder="Enter template name"
        [disabled]="readonly()"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select
        [ngModel]="selectedScheduleType()"
        (ngModelChange)="selectedScheduleType.set($event)"
        [disabled]="readonly()"
      >
        @for (type of scheduleTypes; track type) {
          <mat-option [value]="type">{{ getLabel(type) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (!hideUserId()) {
      <mat-form-field appearance="outline">
        <mat-label>Template Owner</mat-label>
        <input
          type="text"
          matInput
          placeholder="Search template owner"
          [formControl]="ownerControl"
          [matAutocomplete]="ownerAuto"
          [disabled]="readonly()"
        />
        @if (ownerControl.value && !readonly()) {
          <button
            matSuffix
            mat-icon-button
            class="edit-schedule-template__clear-owner-button"
            type="button"
            aria-label="Clear template owner"
            (click)="clearOwnerInput()"
          >
            <mat-icon class="edit-schedule-template__clear-owner-icon">close</mat-icon>
          </button>
        }
        <mat-autocomplete
          #ownerAuto="matAutocomplete"
          [displayWith]="userAccountDisplayFn.bind(this)"
          (optionSelected)="onUserAccountSelected($event.option.value)"
        >
          @for (userAccount of filteredUserAccounts(); track userAccount.item) {
            <mat-option [value]="userAccount">
              {{ getUserAccountLabel(userAccount) }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
    @if (!hideCustomerVisibility() && selectedUserAccountId() === -1) {
      <mat-checkbox
        [ngModel]="visibleForCustomers()"
        (ngModelChange)="onDefaultTemplateChange($event)"
        [disabled]="readonly()"
        color="accent"
      >
        Visible For Customers
      </mat-checkbox>
    }
  </div>

  @if (selectedScheduleType()) {
    <rc-schedule-view
      [onlyShow]="[selectedScheduleType()]"
      [forceShow]="[selectedScheduleType()]"
      [hideCameraFormat]="false"
      [videoFormatsOptions]="videoFormatsOptions()"
      [photoFormatsOptions]="photoFormatsOptions()"
      [showLoadFromTemplates]="hasTemplatesForSelectedScheduleType()"
      [showSaveAsTemplate]="false"
      [showRemoveSchedule]="false"
      [readonly]="readonly()"
      [hasHighActivityCameraTrigger]="hasHighActivityCameraTrigger()"
    ></rc-schedule-view>
  } @else {
    <div class="edit-schedule-template__error-message">
      Please select a schedule type to create a new schedule template.
    </div>
  }

  @if (!readonly()) {
    <div class="edit-schedule-template__actions">
      <button
        mat-button
        color="primary"
        [disabled]="!templateName() || !selectedScheduleType() || !isScheduleFilled()"
        (click)="onSave()"
      >
        <mat-icon color="accent">{{ buttonIcon() }}</mat-icon>
        {{ buttonLabel() }}
      </button>
    </div>
  }
</div>
